<template>
  <v-dialog v-model="dialog" max-width="450">
    <v-sheet class="text-center">
      <div class="pa-6">
        <span class="sokoDeep--text titan">
          Welcome to <br />
          SokoDelivery.
        </span>

        <p class="my-3 black--text">
          This is the first of its kind in Africa. SokoDelivery is a service
          that brings together the best delivery companies onto a single
          platform to make it easy for you to be able to find a vehicle to suit
          your delivery needs. We provide many different types of vehicle
          options from bicycles, tuk tuks, cars, trucks to aeroplanes. It's
          fast, secure and affordable.
        </p>

        <a
          style="text-decoration:underline;"
          @click="dialog = false"
          class="sokoDeep--text"
        >
          click here to get started...
        </a>
      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: true,
  }),

  watch: {
    dialog() {
      sessionStorage.setItem("known", true);
    },
  },

  mounted() {
    if (this.$route.path !== "/") this.dialog = false;
    else if (sessionStorage.getItem("known")) this.dialog = false;
    else this.dialog = true;
  },
};
</script>

<style scoped>
.titan {
  font-family: "Titan One", cursive;
  font-size: 1.8rem;
}
</style>
